import { deleteApi, getApi, postApi, putApi } from "@/utils/http";

//查询会话列表
export const getConversitionListApi = (params) => {
    return getApi('/api/v1/crm/tools/conversation', params);
}

//批量删除会话列表
export const deleteConversitionApi = (data) => {
    return deleteApi('/api/v1/crm/tools/conversation/chat', data);
}

// 查询消息
export const getMessageListApi = (params) => {
    return getApi('/api/v1/crm/tools/conversation/find', params);
}

// 查询有消息的账号id list
export const getHasIdListApi = (list) => {
    return postApi('/video/auth/conversation/unread_uids', {
        uids: list
    });
}

// 查询客户信息
export const getClientApi = (params) => {
    return getApi('/video/auth/conversation/chat/member', params);
}
// 修改客户信息
export const putClientApi = (data) => {
    return putApi('/video/auth/conversation/chat/member', data);
}
// 获取团队信息
export const getTeamInfo = () => {
    return getApi('/api/v1/crm/tools');
}
